import { ICoreLogger } from "../api/ICoreLogger";
import { ICoreLoggerFactory } from "../api/ICoreLoggerFactory";
import { LoggerFactory } from "../impl/LoggerFactory";
import { Loggers } from "../../../../../index";

/**
 * @private
 *
 * Allows you to get unique logger without access to the injector.
 * @example
 * <listing version="3.0">
 *     var logger:ICoreLogger = CoreLoggerUtil.getLogger( this );
 * </listing>
 */
export class CoreLoggerUtil {
    private static _factory: ICoreLoggerFactory;

    public static init(factory: ICoreLoggerFactory = new LoggerFactory(Loggers)): void {
        CoreLoggerUtil._factory = factory;
    }

    public static getLogger(value: string | any): ICoreLogger {
        if (typeof value === "string") {
            return CoreLoggerUtil._factory.getLoggerFor(value);
        }
        else {
            return CoreLoggerUtil._factory.getLoggerForObject(value);
        }
    }
}

